import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import { setLockMode } from "@kubera/common";

import { useBiometricRef } from "../root/BiometricComponentExports";

const ThemeSwitchDiv = styled.div``;

const LockSwitchComponent = ({ className, children, mode, onClick, ...props }) => {
  const dispatch = useDispatch();
  const biometricRef = useBiometricRef();

  const switchMode = async () => {
    const isSuccess = await biometricRef.current?.handleBiometricCheck(mode, true);
    if (!isSuccess) return;
    dispatch(setLockMode(mode));

    if (onClick) {
      onClick();
    }
  };

  return (
    <ThemeSwitchDiv className={className} {...props} onClick={switchMode}>
      {children}
    </ThemeSwitchDiv>
  );
};

export default LockSwitchComponent;
